export default "__VITE_ASSET__sQEzrTHm__"